import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ProfilRole {
  id?: number;
  name: string;
  libelle: string;
  description?: string;
  icone?: string;
  menusJson?: string;
  actif?: boolean;
}

@Injectable({ providedIn: 'root' })
export class RoleService {
  private api = `${environment.apiurl}profils-roles`;

  constructor(private http: HttpClient) {}

  listerRoles(): Observable<ProfilRole[]> {
    return this.http.get<ProfilRole[]>(this.api);
  }

  obtenirProfil(id: number): Observable<ProfilRole> {
    return this.http.get<ProfilRole>(`${this.api}/${id}`);
  }

  creerProfil(p: ProfilRole): Observable<ProfilRole> {
    return this.http.post<ProfilRole>(this.api, p);
  }

  modifierProfil(id: number, p: ProfilRole): Observable<ProfilRole> {
    return this.http.put<ProfilRole>(`${this.api}/${id}`, p);
  }

  sauvegarderMenus(id: number, menusJson: string): Observable<ProfilRole> {
    return this.http.patch<ProfilRole>(`${this.api}/${id}/menus`, { menusJson });
  }

  supprimerProfil(id: number): Observable<void> {
    return this.http.delete<void>(`${this.api}/${id}`);
  }
}
